type Translate = (message: string, options?: Record<string, unknown>) => string;

/**
 * The label shown next to the logged-at time for a synced activity.
 *
 * When the provider reports a device name it is shown on its own (e.g.
 * "Garmin fenix 8") — it already includes the brand. Without a device name
 * (Apple Health / Google Fit, or an Open Wearables source that didn't report
 * one) the existing synced label ("Synced workout") is returned.
 */
export const getSyncedSourceLabel = (
  deviceName: string | null | undefined,
  t: Translate
): string => {
  return deviceName ? deviceName : t('tracker.history.entryType.synced');
};
